import { SupplierBillDetailView } from "@medicorepay/ui";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { purchaseInvoiceService } from "../../services/purchase-invoice.service";

export function SupplierBillDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const loadBill = useCallback(
    (billId: string) => purchaseInvoiceService.get(billId),
    [],
  );

  if (!id) return null;
  return (
    <SupplierBillDetailView
      billId={id}
      loadBill={loadBill}
      postBill={(billId) => purchaseInvoiceService.post(billId)}
      voidBill={(billId, reason) => purchaseInvoiceService.void(billId, reason)}
      onBack={() => navigate("/supplier-bills")}
      onOpenReceipt={(receiptId) => navigate(`/goods-receipts/${receiptId}`)}
      onCreateReturn={(receiptId) =>
        navigate(`/purchase-returns/create?grnId=${receiptId}`)
      }
    />
  );
}
